import { makeStyles } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';

export const useStyles = makeStyles(theme => ({
	root: {
		padding: '100px 90px',
		width: 555,
		maxWidth: '90%',
		[theme.breakpoints.down('md')]: {
			padding: '50px 45px'
		}
	},
	cancelIcon: {
		position: "absolute",
		top: 0,
		right: 0,
		margin: 10
	},
	title: {
		fontWeight: "bold",
		fontSize: 38,
		padding: 0,
		marginBottom: 30
	},
	content: {
		fontWeight: "normal",
		fontSize: 14,
		marginBottom: 35,
		padding: 0,
		lineHeigh: 22
	},
	actionsContainer: {
		paddingBottom: 0
	},
	buttonLabel: {
		fontSize: 14
	},
	removeButtonLabel: {
		color: "#FFF"
	},
	confirmButtonLabel: {
		color: "#000"
	},
	confirmButtonModeconfirm: {
		backgroundColor: theme.palette.primary.main,
		'&:hover': {
			backgroundColor: theme.palette.primary.light
		}
	},
	confirmButtonModeremove: {
		backgroundColor: red[400],
		'&:hover': {
			backgroundColor: red[500]
		}
	},
	additionalContentWrapper: {
		flex: 1,
		marginRight: 40
	}
}));
